/** Domain service module: group.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

export const TROPA_RAMOS = [
  { value: 'filhotes', title: 'Filhote' },
  { value: 'lobinho', title: 'Lobo' },
  { value: 'escoteiro', title: 'Escoteiro' },
  { value: 'senior', title: 'Sênior' },
  { value: 'pioneiro', title: 'Pioneiro' },
]

class GroupService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/group/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/group/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  get(objId) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/group/${objId}`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class GroupMemberService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/groupMember/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  delete(objId) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/groupMember/${objId}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/groupMember/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class SubGroupService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/subGroup/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/subGroup/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  search(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _resultSubGroup = await request(`${API_BASE_URL}/subGroup/search`, 'post', data)
        resolve(_resultSubGroup?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  get(objId) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/subGroup/${objId}`, 'get')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/subGroup/delete/${id}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  searchChefes(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/subGroup/searchChefes`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
  setRamo(data) {
    return new Promise(async (resolve, reject) => {
      try {
        const _result = await request(`${API_BASE_URL}/subGroup/setRamo`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    })
  }
}

class SubGroupMemberService {
  update(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/subGroupMember/update`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  delete(objId) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/subGroupMember/${objId}`, 'delete')
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  insertMultiGroups(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/subGroupMember/insertmultigroups`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/subGroupMember/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

export const group = new GroupService()
export const groupMember = new GroupMemberService()
export const subGroup = new SubGroupService()
export const subGroupMember = new SubGroupMemberService()
